export const TOASTER_VARIANT = {
	SUCCESS: 'success',
	WARNING: 'warning',
	DANGER: 'danger',
};
